import { SypMeasureNew } from './syp_file.ts';

export function roundMeasurePercent(percent: number): number {
  return Math.round(percent * 100) / 100;
}

export function getMeasurePercentages(measures: SypMeasureNew[]): number[] | undefined {
  if (measures.length === 0) {
    return;
  }
  // Weight each measure by real time (beatCount / tempo) so that slower measures
  // occupy a proportionally larger share of the progress bar
  let currentTempo = measures[0].tempo ?? 100;
  const durations = measures.map((measure) => {
    if (measure.tempo !== undefined) {
      currentTempo = measure.tempo;
    }
    return measure.beatCount / currentTempo;
  });
  const totalDuration = durations.reduce((accum, value) => accum + value, 0);
  if (!totalDuration) {
    return;
  }
  const percentages: number[] = [];
  let percentTotal = 0;
  for (const duration of durations) {
    percentages.push(roundMeasurePercent(percentTotal));
    percentTotal += (100 * duration) / totalDuration;
  }
  return percentages;
}

export function getMeasureStartTick(measureIndex: number, measures: SypMeasureNew[], ticksPerBeat: number): number {
  let cumulativeBeats = 0;
  for (let i = 0; i < measureIndex; i++) {
    cumulativeBeats += measures[i].beatCount;
  }
  return cumulativeBeats * ticksPerBeat;
}

export function getMeasureFromPercent(
  percent: number,
  percentages: number[] | undefined,
): {
  measureIndex: number | undefined;
  measurePercent: number | undefined;
} {
  // measure-based song location currently does not work for vocals
  if (percentages && percentages.length > 1) {
    for (let index = 0; index < percentages.length; index++) {
      if (percentages[index] > percent) {
        return {
          measureIndex: index - 1,
          measurePercent: percentages[index - 1],
        };
      }
    }
    return {
      measureIndex: percentages.length - 1,
      measurePercent: percentages[percentages.length - 1],
    };
  }
  return { measureIndex: undefined, measurePercent: undefined };
}
